import { baseAPI } from "./baseService";
import { MALSAPI, SOURCES } from "./serviceConstants";


export const sourceAPI = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getSourceDataById: builder.query({
      query: ({sourceId,catalogueId}) => {
          return { url: `${MALSAPI}/${SOURCES}/${sourceId}`, params: { catalogue_id:catalogueId } }
      },
      providesTags:["source"]
    }),
    getSourceImagesById: builder.query({
      query: ({sourceId,catalogueId}) => {
        return { url: `${MALSAPI}/${SOURCES}/${sourceId}/images`, params: { catalogue_id:catalogueId } }
    },
      providesTags:["source"]
    }),
    getSpectralPlotData: builder.query({
      query: ({sourceId,catalogueId}) => {
        return { url: `${MALSAPI}/${SOURCES}/${sourceId}/plot`, params: { catalogue_id:catalogueId } }
    },
    }),
   }),
});

export const {
  useGetSourceDataByIdQuery,
  useGetSourceImagesByIdQuery,
  useGetSpectralPlotDataQuery
  } =
  sourceAPI;

